<script lang="ts">
    import {
        VimeSettings,
        VimeMenuRadioGroup,
        VimeMenuRadio,
    } from "@vime/svelte";
    import { currentSegmentIdx } from "../stores/segment";
    import { segments } from "../constants/segments";

    const onCheck = (idx: number): void => {
        if (idx !== $currentSegmentIdx) $currentSegmentIdx = idx;
    };
</script>

<style>
    main {
        --vm-settings-width: 50;
    }
</style>

<main>
    <VimeSettings pin="bottomRight">
        <VimeMenuRadioGroup value={`${$currentSegmentIdx}`}>
            {#each segments as s, i}
                <VimeMenuRadio
                    label={`#${i + 1}`}
                    value={`${i}`}
                    checked={i === $currentSegmentIdx}
                    on:vCheck={() => onCheck(i)} />
            {/each}
        </VimeMenuRadioGroup>
    </VimeSettings>
</main>
